export default __webpack_public_path__ + "static/media/deauville22.6f9e6fc9.jpg";